var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.valid)?_c('div',{ref:"chart",staticClass:"ai-chart",attrs:{"role":"img","aria-label":_vm.chart.title}}):_c('p',[_vm._v("Chart data is unavailable.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }